/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core EXT Release 1.0.0.a
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders,
    HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';

import { map } from 'rxjs/operators';
import { CustomHttpUrlEncodingCodec } from '../encoder';
@Injectable()
export class DashboardService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    public defaultHeaders = new HttpHeaders();

    httpOptions: any;
    constructor(protected httpClient: HttpClient) {
        let token = localStorage.getItem("id_token");
        this.httpOptions = {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                'Content-Type': 'application/json'
            })
        };

    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getDashboardGraphDetails
     * @param public_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    async getDashboardGraphDetails(publicId: string, accountId: string, year: string, observe: any = 'body', reportProgress: boolean = false){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDashboardGraphDetails.');
        }
        return this.httpClient.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/dashboard?account_id=${encodeURIComponent(String(accountId))}&year=${encodeURIComponent(String(year))}`).toPromise();
    }

    getDashboardGraphDetailsWidget(publicId: string, currencySymbol:string){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDashboardGraphDetailsWidget.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (publicId !== undefined && publicId !== null && publicId.toString() !== '') {
            queryParameters = queryParameters.set('publicId', <any>publicId);
        }

        if (currencySymbol !== undefined && currencySymbol !== null && currencySymbol.toString() !== '') {
            queryParameters = queryParameters.set('currencySymbol', <any>currencySymbol);
        }
        return this.httpClient.get(`${this._kcmssvcURL}/payouts_invoices_status?customer_public_id=${encodeURIComponent(String(publicId))}&currency=${encodeURIComponent(String(currencySymbol))}`);
    }


}//end class
